// pages/BlogPageVersion2.jsx
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get_blogs } from '../store/reducers/blogClientReducer';
import { Link } from 'react-router-dom';
import Heders from '../components/Headers';
import Footer from '../components/Footer';

const BlogPageVersion2 = () => {
  const dispatch = useDispatch();
  const { blogs = [], loader = false } = useSelector((state) => state.blogs || {});

  // Predefined categories
  const categories = ['All', 'News', 'Sales', 'Know About Seller', 'Street Updates'];
  const [selectedCategory, setSelectedCategory] = useState('All');

  useEffect(() => {
    dispatch(get_blogs({}));
  }, [dispatch]);

  const handleCategoryClick = (cat) => {
    setSelectedCategory(cat);
    if (cat === 'All') {
      dispatch(get_blogs({}));
    } else {
      dispatch(get_blogs({ category: cat }));
    }
  };

  return (
    <>
      <Heders />
      <div className="min-h-screen flex flex-col">
        {/* Top Banner / Hero Section */}
        <div
          className="relative w-full h-[300px] bg-cover bg-center"
          style={{
            backgroundImage: `url("https://images.lifestyleasia.com/wp-content/uploads/sites/5/2022/09/02192519/generic_yongkang_street_taipei_taiwan_873acbcff0-scaled-1-1.jpeg")`,
          }}
        >
          <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-white px-4">
            <h1 className="text-4xl font-bold mb-2">Latest Blog Insights</h1>
            <p className="max-w-2xl text-center">
              Discover new trends, street market updates, and behind-the-scenes stories that shape our e-commerce world.
            </p>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="w-full bg-white shadow-sm py-4">
          <div className="max-w-7xl mx-auto px-4 flex gap-4 overflow-x-auto">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => handleCategoryClick(cat)}
                className={`flex-shrink-0 px-4 py-2 text-sm rounded-full font-medium border transition-colors ${
                  selectedCategory === cat
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'text-gray-700 border-gray-300 hover:bg-blue-50'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Blog Cards */}
        <div className="max-w-7xl w-full mx-auto px-4 py-8 flex-1">
          {loader ? (
            <div className="text-center py-10">
              <p className="text-lg">Loading blogs...</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogs && blogs.length > 0 ? (
                blogs.map((blog) => (
                  <div key={blog._id} className="bg-white rounded-lg shadow hover:shadow-lg transition flex flex-col">
                    {blog.images && blog.images[0] && (
                      <img
                        src={blog.images[0]}
                        alt={blog.title}
                        className="w-full h-48 object-cover rounded-t-lg"
                      />
                    )}
                    <div className="p-4 flex-1 flex flex-col">
                      <h3 className="text-2xl font-semibold mb-2">{blog.title}</h3>
                      {blog.header && (
                        <p className="text-gray-600 text-sm mb-2">{blog.header}</p>
                      )}
                      <div className="mt-4">
                        <Link
                          to={`/blog-details/${blog._id}`}
                          className="inline-block text-blue-600 hover:underline font-medium"
                        >
                          View More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No blogs found.</p>
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPageVersion2;
